import React from "react";
import {
  Col,
  Row,
  Form,
  Input,
  Select,
  DatePicker,
  Checkbox,
  Switch,
} from "antd";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import DeleteIcon from "../../../Assets/delete.svg";

const filterOption = (input, option) =>
  (option?.children || "").toLowerCase().indexOf(input.toLowerCase()) >= 0;

function ExperienceFormBlock({
  field,
  form,
  isParent,
  employerLocked,
  expanded,
  onToggle,
  onRemove,
  jobTitle,
  industry,
  discipline,
  induction,
  skills,
}) {
  const { name, ...restField } = field;
  const currentRole = Form.useWatch(["experiences", name, "currentRole"], form);
  const hasReferee = Form.useWatch(["experiences", name, "hasReferee"], form);
  const employerName = Form.useWatch(
    ["experiences", name, "employerName"],
    form
  );
  const selectedJobTitle = Form.useWatch(["experiences", name, "jobTitle"], form);
  const jobTitleLabel = jobTitle?.find((item) => item.id === selectedJobTitle)
    ?.name;

  return (
    <div className={`experienceFormBlock ${expanded ? "expanded" : ""}`}>
      <div className="experienceFormBlockHeader" onClick={onToggle}>
        <div>
          <p className="experienceFormBlockTitle">
            {isParent ? "Primary experience" : "Related experience"}
          </p>
          <p className="experienceFormBlockSubtitle">
            {jobTitleLabel || employerName || "New role"}
          </p>
        </div>
        <div className="experienceFormBlockActions">
          {!isParent && (
            <img
              src={DeleteIcon}
              alt="remove"
              className="experienceFormBlockRemove"
              onClick={(event) => {
                event.stopPropagation();
                onRemove?.();
              }}
            />
          )}
          {expanded ? <UpOutlined /> : <DownOutlined />}
        </div>
      </div>
      {expanded && (
        <div className="experienceFormBlockBody">
          <Form.Item {...restField} name={[name, "id"]} hidden>
            <Input />
          </Form.Item>
          <Form.Item {...restField} name={[name, "localId"]} hidden>
            <Input />
          </Form.Item>
          <Row gutter={24}>
            <Col xs={12}>
              <Form.Item
                {...restField}
                label="Employer*"
                name={[name, "employerName"]}
                rules={[
                  {
                    required: true,
                    message: "Please enter employer name",
                  },
                ]}
              >
                <Input placeholder="Employer" disabled={employerLocked} />
              </Form.Item>
            </Col>
            <Col xs={12}>
              <Form.Item
                {...restField}
                label="Project Name"
                name={[name, "projectName"]}
              >
                <Input placeholder="Project Name" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col xs={12}>
              <Form.Item
                {...restField}
                label="Job Title*"
                name={[name, "jobTitle"]}
                rules={[
                  {
                    required: true,
                    message: "Please select job title",
                  },
                ]}
              >
                <Select
                  placeholder="Job title"
                  showSearch
                  optionFilterProp="children"
                  filterOption={filterOption}
                >
                  {jobTitle?.map((item, key) => (
                    <Select.Option key={key} value={item.id}>
                      {item.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={12}>
              <Form.Item
                {...restField}
                label="Industry*"
                name={[name, "industry"]}
                rules={[
                  {
                    required: true,
                    message: "Please select industry",
                  },
                ]}
              >
                <Select
                  placeholder="Industry"
                  showSearch
                  optionFilterProp="children"
                  filterOption={filterOption}
                >
                  {industry?.map((item, key) => (
                    <Select.Option key={key} value={item.id}>
                      {item.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col xs={12}>
              <Form.Item
                {...restField}
                label="Discipline*"
                name={[name, "discipline"]}
                rules={[
                  {
                    required: true,
                    message: "Please select discipline",
                  },
                ]}
              >
                <Select
                  placeholder="Discipline"
                  showSearch
                  optionFilterProp="children"
                  filterOption={filterOption}
                >
                  {discipline?.map((item, key) => (
                    <Select.Option key={key} value={item.id}>
                      {item.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={12}>
              <Form.Item
                {...restField}
                label="Inductions*"
                name={[name, "inductions"]}
                rules={[
                  {
                    required: true,
                    message: "Please select inductions",
                  },
                ]}
              >
                <Select
                  mode="multiple"
                  maxTagCount="responsive"
                  placeholder="Inductions"
                  showSearch
                  optionFilterProp="children"
                  filterOption={filterOption}
                >
                  {induction?.map((item, key) => (
                    <Select.Option key={key} value={item.id}>
                      {item.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col xs={12}>
              <Form.Item
                {...restField}
                label="Job Description, Responsibilties, Skills*"
                name={[name, "skills"]}
                rules={[
                  {
                    required: true,
                    message: "Please select skills",
                  },
                ]}
              >
                <Select
                  mode="multiple"
                  maxTagCount="responsive"
                  placeholder="Skills"
                  showSearch
                  optionFilterProp="children"
                  filterOption={filterOption}
                >
                  {skills?.map((item, key) => (
                    <Select.Option key={key} value={item.id}>
                      {item.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={12}>
              <Form.Item
                {...restField}
                label="Start Date*"
                name={[name, "startDate"]}
                rules={[
                  {
                    required: true,
                    message: "Please select start date",
                  },
                ]}
              >
                <DatePicker
                  className="w-100"
                  format={"DD-MM-YYYY"}
                  placeholder="Select start date"
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col xs={12}>
              <Form.Item
                {...restField}
                label="End Date"
                name={[name, "endDate"]}
              >
                <DatePicker
                  className="w-100"
                  format={"DD-MM-YYYY"}
                  placeholder="Select end date"
                  disabled={!!currentRole}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col xs={12}>
              <Form.Item
                {...restField}
                name={[name, "hasReferee"]}
                valuePropName="checked"
              >
                <Checkbox>Referee Details</Checkbox>
              </Form.Item>
            </Col>
            <Col xs={12}>
              <Form.Item
                {...restField}
                name={[name, "currentRole"]}
                valuePropName="checked"
              >
                <span style={{ marginRight: "10px" }}>Current Role</span>
                <Switch
                  checked={!!currentRole}
                  onChange={(checked) => {
                    form.setFieldValue(
                      ["experiences", name, "currentRole"],
                      checked
                    );
                    if (checked) {
                      form.setFieldValue(
                        ["experiences", name, "endDate"],
                        null
                      );
                    }
                    setTimeout(() => {
                      form.validateFields([["experiences", name, "endDate"]]);
                    }, 0);
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
          {hasReferee ? (
            <>
              <Row gutter={24}>
                <Col xs={12}>
                  <Form.Item
                    {...restField}
                    label="Referee Name*"
                    name={[name, "refereeName"]}
                    rules={[
                      {
                        required: true,
                        message: "Please enter referee name",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col xs={12}>
                  <Form.Item
                    {...restField}
                    label="Referee Position*"
                    name={[name, "refereePosition"]}
                    rules={[
                      {
                        required: true,
                        message: "Please enter referee position",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col xs={12}>
                  <Form.Item
                    {...restField}
                    label="Referee Email/ Phone Number*"
                    name={[name, "refereeContact"]}
                    rules={[
                      {
                        required: true,
                        message: "Please enter referee email or phone number",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
            </>
          ) : null}
        </div>
      )}
    </div>
  );
}

export default ExperienceFormBlock;
